import { render, staticRenderFns } from "./fission-send-collect.vue?vue&type=template&id=5ee0d478&scoped=true"
import script from "./fission-send-collect.vue?vue&type=script&lang=ts"
export * from "./fission-send-collect.vue?vue&type=script&lang=ts"
import style0 from "./fission-send-collect.vue?vue&type=style&index=0&id=5ee0d478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee0d478",
  null
  
)

export default component.exports